import FetchService from "./Shared/FetchService";
const baseURL = "/aviso/coach";
export default class CoachService {
    static search(query, max) {
        return FetchService.get("/aviso/advisor/getCoachList", { q: query, max });
    }
    static getTermForCoach() {
        return FetchService.getSingleResponse("/aviso/advisor/getTermToRepresentCoach");
    }
    static assignCoach(studentAffiliationId, coachAffiliationId) {
        return FetchService.postSingleResponse("/aviso/advisor/assignCoach", {
            studentAffiliationId,
            coachAffiliationId,
        });
    }
    static currentUserCanSeeCoach() {
        return FetchService.getSingleResponse("/aviso/advisor/canCurrentUserViewCoach");
    }
}
